var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9024 0.58374H2.09756C0.940889 0.58374 0 1.52463 0 2.6813V13.3191C0 14.4755 0.940889 15.4164 2.09756 15.4164H17.9024C19.0591 15.4164 20 14.4755 20 13.3191V2.6813C20 1.52463 19.0591 0.58374 17.9024 0.58374ZM17.9024 1.68263C17.9444 1.68263 17.9847 1.68996 18.0253 1.69507L10 9.05774L1.97467 1.69507C2.01533 1.68996 2.05556 1.68263 2.09756 1.68263H17.9024ZM18.9011 13.3191C18.9011 13.8695 18.4531 14.3175 17.9024 14.3175H2.09756C1.54689 14.3175 1.09889 13.8695 1.09889 13.3191V2.6813C1.09889 2.58996 1.11511 2.50307 1.13822 2.41907L7.22178 8.00019L3.38844 11.5169C3.16489 11.7217 3.14978 12.0695 3.35489 12.2931C3.46333 12.4111 3.61133 12.4711 3.76 12.4711C3.89267 12.4711 4.02578 12.4233 4.13133 12.3264L8.03444 8.74574L9.62844 10.208C9.73356 10.3044 9.86667 10.3526 9.99978 10.3526C10.1329 10.3526 10.2662 10.3044 10.3713 10.208L11.9653 8.74574L15.8684 12.3264C15.974 12.4233 16.1071 12.4711 16.2398 12.4711C16.3884 12.4711 16.5367 12.4113 16.6449 12.2931C16.85 12.0695 16.8351 11.7217 16.6116 11.5169L12.7782 8.00019L18.8618 2.4193C18.8849 2.5033 18.9011 2.59018 18.9011 2.68152V13.3191Z",
    fill: "#DCE1E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailEnvelope);
export default __webpack_public_path__ + "static/media/EmailEnvelope.2538cc42a138d8adc0ad76aa66dce573.svg";
export { ForwardRef as ReactComponent };